import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiUrls } from '../../../../../config/api-urls/api-urls';
import { MainService } from '../../../../../provider/main.service';
declare var $: any;

@Component({
  standalone: false,
  selector: 'app-faq-mgt',
  templateUrl: './faq-mgt.component.html',
  styleUrls: ['./faq-mgt.component.css']
})
export class FaqMgtComponent implements OnInit {

  searchForm: FormGroup | any;
  // whichmodal: string = 'enable';
  itemPerPage = 10;
  currentPage = 1;
  total: any;
  helplineId: any
  faqList: any = [];
  faqId: any;

  constructor(private router: Router,
    public mainService: MainService) { }
  ngOnInit() {
    this.searchFormValidation();
    this.getFaqList()
  }

  searchFormValidation() {
    this.searchForm = new FormGroup({
      search: new FormControl('')
    });
  }



  pagination(event: any) {
    this.currentPage = event;
    this.getFaqList()
  }

  // ------- get helpline number list -------- //

  getFaqList() {

    this.mainService.showSpinner();
    this.mainService.getApi(ApiUrls.faqList, 0).subscribe((res: any) => {
      if (res.responseCode == 200) {
        this.faqList = res.result ? res.result : '';
        this.total = res.result.total;
        this.mainService.hideSpinner();
      } else {
        this.faqList = res.result ? res.result : ''
        this.mainService.hideSpinner();
      }
    })
  }

  addFaq() {
    this.router.navigate(['add-faq'])
  }
  viewUser(id: any) {
    this.router.navigate(['view-faq/' + id])
  }
  editFaq(id: any) {
    this.router.navigate(['/edit-faq/' + id])

  }
  deleteFaqModal(id: any) {
    this.faqId = id
    $('#delete').modal('show')
  }

  deleteFaq() {
    const data = {}
    this.mainService.showSpinner();
    this.mainService.deleteApi(ApiUrls.deleteFaq + `?faqId=${this.faqId}`, data, 1).subscribe((res: any) => {
      $('#delete').modal('hide');
      this.mainService.hideSpinner();
      if (res.responseCode == 200) {
        this.faqList = res.result;
        this.getFaqList()
        this.mainService.successToast(res.responseMessage);
      } else {
        this.mainService.errorToast(res.responseMessage)
      }
    })
  }

}
